import { Flex } from "antd";
import { styled } from "styled-components";

export const TimeslotsContainer = styled.div`
  margin-top: 20px;

  .ant-carousel .slick-next,
  .ant-carousel .slick-prev {
    top: 20px !important;
    color: black !important;
  }
`;

export const Timeslot = styled.div<{ active: boolean; mainColor: string }>`
  background: ${({ active, mainColor }) => (active ? mainColor : "#817a8352")};
  color: ${({ active }) => (active ? "white" : "#080808")};
  padding: 5px 10px;
  border-radius: 7px;
  margin: 5px 0;
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    background: ${({ mainColor }) => mainColor};
    opacity: 0.8;
    color: white;
  }
`;

export const StyledNotification = styled(Flex)<{ isButton?: boolean }>`
  background: #f6f6f6;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #d5d0d0;
  cursor: ${({ isButton }) => (isButton ? "pointer" : "default")};
`;
